/* Embroly B2B landing scripts. No dependencies, load with defer.
   Modules: load more, sticky buttons, price calculator, need-by checker, team order, tier progress,
   hero media carousel, gallery video tiles, chat links, share-estimate buttons. */
(function () {
  'use strict';
  // every section renders the asset snippet, so the file can be included more than once: run once
  if (window.EmbB2B) return;
  window.EmbB2B = { version: 2 };

  /* ---------- shared helpers ---------- */
  var CONFIG = null;
  function config() {
    if (CONFIG) return CONFIG;
    var el = document.querySelector('script[data-emb-config]');
    try { CONFIG = el ? JSON.parse(el.textContent) : {}; } catch (e) { CONFIG = {}; }
    // delivery times set in the hero calculator's theme editor settings override the snippet defaults
    qsa(document, 'script[data-emb-timing]').forEach(function (t) {
      try { var o = JSON.parse(t.textContent); Object.keys(o).forEach(function (k) { CONFIG[k] = o[k]; }); } catch (e) {}
    });
    CONFIG.tiers = (CONFIG.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
    return CONFIG;
  }
  function tierFor(qty) {
    var t = null;
    config().tiers.forEach(function (x) { if (qty >= x.min) t = x; });
    return t;
  }
  function nextTier(qty) {
    var tiers = config().tiers;
    for (var i = 0; i < tiers.length; i++) { if (qty < tiers[i].min) return tiers[i]; }
    return null;
  }
  function money(cents) {
    var fmt = config().moneyFormat || '${{amount}}';
    var n = Math.round(cents) / 100;
    function withSep(num, dec, th, ds) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withSep(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withSep(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(n, 0, '.', ',');
        default: return withSep(n, 2, ',', '.');
      }
    });
  }
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function setText(root, sel, text) { qsa(root, sel).forEach(function (el) { el.textContent = text; }); }
  function show(el, on) { if (el) el.hidden = !on; }
  function clampQty(v) { v = parseInt(v, 10); return isNaN(v) || v < 1 ? 1 : Math.min(v, 9999); }

  /* ---------- 1. load more ---------- */
  function initMore(wrap) {
    if (wrap.dataset.embReady) return;
    wrap.dataset.embReady = '1';
    var grid = qs(wrap, '.emb-pgrid');
    if (!grid) return;
    var initial = parseInt(wrap.dataset.initial || '4', 10);
    var batch = parseInt(wrap.dataset.batch || '0', 10);
    var items = grid.children;
    var moreBtn = qs(wrap, '[data-emb-more]');
    var end = qs(wrap, '[data-emb-more-end]');
    var nextUrl = wrap.dataset.nextUrl || '';
    var sectionId = wrap.dataset.sectionId || '';
    var shown = Math.min(initial, items.length);
    var loading = false;
    function setInert() {
      for (var i = 0; i < items.length; i++) {
        if (i >= shown) { items[i].setAttribute('inert', ''); } else { items[i].removeAttribute('inert'); }
      }
    }
    function measure() {
      if (shown >= items.length && !nextUrl) { grid.style.removeProperty('max-height'); return; }
      var last = items[Math.max(0, shown - 1)];
      if (!last) return;
      var peek = window.matchMedia('(max-width: 720px)').matches ? 150 : 230;
      wrap.style.setProperty('--emb-collapsed-h', (last.offsetTop + last.offsetHeight - grid.offsetTop + peek) + 'px');
    }
    function apply() {
      var done = shown >= items.length && !nextUrl;
      wrap.classList.toggle('is-collapsed', !done);
      wrap.classList.toggle('is-expanded', done);
      if (moreBtn) moreBtn.setAttribute('aria-expanded', String(done));
      if (end) end.hidden = !done;
      setInert();
      measure();
    }
    // next page of the collection, rendered by Shopify for this section only
    function loadNext() {
      if (!nextUrl || loading) return Promise.resolve();
      loading = true;
      if (moreBtn) moreBtn.classList.add('is-loading');
      var url = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var w = doc.querySelector('[data-emb-more-wrap]');
          var list = w && w.querySelector('.emb-pgrid');
          if (list) Array.prototype.slice.call(list.children).forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          nextUrl = (w && w.dataset.nextUrl) || '';
        })
        .catch(function () { nextUrl = ''; })
        .then(function () { loading = false; if (moreBtn) moreBtn.classList.remove('is-loading'); });
    }
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var first = shown;
      var want = batch > 0 ? shown + batch : Infinity;
      var fill = function () {
        if (items.length < want && nextUrl && batch > 0) return loadNext().then(fill);
        if (batch === 0 && nextUrl) return loadNext().then(fill);
        return Promise.resolve();
      };
      fill().then(function () {
        shown = Math.min(items.length, want);
        apply();
        var link = items[first] && items[first].querySelector('a');
        if (link) link.focus({ preventScroll: true });
        // keep one page ready so the next click is instant
        if (shown >= items.length - 1 && nextUrl) loadNext().then(apply);
      });
    });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (items.length <= initial && !nextUrl) { if (moreBtn) moreBtn.parentNode.hidden = true; if (end) end.hidden = false; return; }
    apply();
  }

  /* ---------- 2. sticky buttons: auto-align with chat, move overlapping widgets ---------- */
  function initSticky(bar) {
    if (bar.dataset.embReady) return;
    bar.dataset.embReady = '1';
    var offset = parseInt(bar.dataset.offset || '500', 10);
    var hideIds = (bar.dataset.hideOn || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var chatSel = (bar.dataset.chat || '').trim();
    var liftSel = (bar.dataset.lift || '').trim();
    var autoAlign = bar.dataset.autoAlign === 'true';
    var isBar = bar.classList.contains('emb-sticky--bar');
    var mobile = window.matchMedia('(max-width: 720px)');
    var hidden = {};
    var chatEl = null;
    var moved = [];

    function findChat() {
      if (!chatSel) return null;
      var list = [];
      try { list = qsa(document, chatSel); } catch (e) { return null; }
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        var nearBottom = window.innerHeight - r.bottom < 140;
        var rightSide = r.left > window.innerWidth * 0.45;
        if (r.width >= 36 && r.width <= 260 && r.height >= 32 && r.height <= 90 && nearBottom && rightSide) return list[i];
      }
      return null;
    }
    function align() {
      if (!autoAlign || (isBar && mobile.matches)) return;
      chatEl = findChat();
      if (!chatEl) return;
      var r = chatEl.getBoundingClientRect();
      var bottom = Math.max(0, Math.round(window.innerHeight - r.bottom));
      var right = Math.round(window.innerWidth - r.left + (mobile.matches ? 8 : 12));
      var h = Math.round(r.height);
      if (mobile.matches) {
        bar.style.setProperty('--emb-sticky-bottom-m', bottom + 'px');
        bar.style.setProperty('--emb-sticky-right-m', right + 'px');
      } else {
        bar.style.setProperty('--emb-sticky-bottom', bottom + 'px');
        bar.style.setProperty('--emb-sticky-right', right + 'px');
      }
      bar.style.setProperty('--emb-sticky-h', h + 'px');
    }
    function overlaps(a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; }
    function candidates() {
      var out = [];
      if (liftSel) { try { out = qsa(document, liftSel); } catch (e) { out = []; } }
      // floating widgets are usually appended straight to <body>
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (out.indexOf(el) === -1) out.push(el);
      });
      return out.filter(function (el) {
        if (el === bar || el.contains(bar) || bar.contains(el) || el === chatEl || (chatEl && el.contains(chatEl))) return false;
        var cs = window.getComputedStyle(el);
        return cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden';
      });
    }
    function lift(on) {
      moved.forEach(function (el) { el.style.removeProperty('transform'); });
      moved = [];
      if (!on) return;
      var br = bar.getBoundingClientRect();
      var zone = isBar && mobile.matches
        ? { left: 0, right: window.innerWidth, top: br.top - 4, bottom: window.innerHeight }
        : { left: br.left - 4, right: br.right + 4, top: br.top - 4, bottom: br.bottom + 4 };
      var dy = Math.round(window.innerHeight - zone.top + 8);
      candidates().forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.width === 0 || r.height === 0 || r.height > window.innerHeight * 0.6) return;
        var mustMove = isBar && mobile.matches ? r.bottom > zone.top : overlaps(r, zone);
        if (!mustMove) return;
        el.classList.add('emb-lifted');
        el.style.setProperty('transform', 'translateY(-' + (isBar && mobile.matches ? dy : Math.round(r.bottom - zone.top + 8)) + 'px)', 'important');
        moved.push(el);
      });
    }
    var visible = false;
    function update() {
      var anyHide = Object.keys(hidden).some(function (k) { return hidden[k]; });
      var on = window.scrollY > offset && !anyHide;
      if (on !== visible) {
        visible = on;
        bar.classList.toggle('is-visible', on);
        window.setTimeout(function () { lift(visible); }, on ? 260 : 0);
      }
    }
    function refresh() { align(); if (visible) lift(true); }
    if ('IntersectionObserver' in window) {
      hideIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { hidden[id] = e.isIntersecting; });
          update();
        }, { threshold: 0.15 }).observe(el);
      });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', refresh);
    if (mobile.addEventListener) mobile.addEventListener('change', refresh);
    // chat and badge widgets load late: re-check a few times
    [600, 2000, 4500, 8000].forEach(function (ms) { window.setTimeout(refresh, ms); });
    align();
    update();
  }

  /* ---------- 3. price + delivery calculator ---------- */
  function rangeBD(start, a, b) { return [addBusinessDays(start, a), addBusinessDays(start, b)]; }
  function fmtRange(r) {
    var a = fmtShort(r[0]), b = fmtShort(r[1]);
    return a === b ? a : a + ' - ' + b;
  }
  function fmtShort(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function initCalc(root) {
    if (root.dataset.embReady) return;
    root.dataset.embReady = '1';
    var c = config();
    var qtyInput = qs(root, '[data-emb-qty]');
    var range = qs(root, '[data-emb-range]');
    var select = qs(root, '[data-emb-product]');
    var need = qs(root, '[data-emb-need]');
    var status = qs(root, '[data-emb-status]');
    var go = qs(root, '[data-emb-go]');
    var share = qs(root, '[data-emb-share]');
    var tplEl = qs(root, 'template[data-emb-cta-tpl]');
    var ctaTpl = tplEl ? tplEl.innerHTML.trim() : '';
    var rushEl = qs(root, 'template[data-emb-rush-contact]');
    var rushUrl = rushEl ? rushEl.innerHTML.trim() : '';
    // item words come from the section settings (hat/hats, sweatshirt/sweatshirts...)
    var U1 = root.dataset.unitOne || 'hat', UN = root.dataset.unitMany || 'hats';
    function capW(w) { return w.charAt(0).toUpperCase() + w.slice(1); }
    var quoteMin = c.quoteMin || 100;
    var max = parseInt(root.dataset.max || (range ? range.max : '100'), 10);
    var pv = c.previewDays || [1, 2], pr = c.productionDays || [1, 2], sh = c.shippingDays || [2, 5];
    // piecewise slider scale: every gap between tier marks gets the same width
    var knots = [1];
    c.tiers.forEach(function (t) { if (t.min > 1 && t.min < max) knots.push(t.min); });
    if (quoteMin > 1 && quoteMin < max && knots.indexOf(quoteMin) === -1) knots.push(quoteMin);
    knots.push(max);
    knots.sort(function (a, b) { return a - b; });
    var SCALE = 1000;
    function qtyToPos(q) {
      q = Math.max(1, Math.min(max, q));
      var seg = SCALE / (knots.length - 1);
      for (var i = 0; i < knots.length - 1; i++) {
        if (q <= knots[i + 1]) return Math.round(seg * i + seg * (q - knots[i]) / (knots[i + 1] - knots[i]));
      }
      return SCALE;
    }
    function posToQty(p) {
      var seg = SCALE / (knots.length - 1);
      var i = Math.min(knots.length - 2, Math.floor(p / seg));
      return Math.round(knots[i] + (knots[i + 1] - knots[i]) * (p - seg * i) / seg);
    }
    if (range) { range.min = 0; range.max = SCALE; range.step = 1; }

    // prefill from a shared estimate link
    var params = new URLSearchParams(window.location.search);
    if (params.get('emb_qty')) qtyInput.value = clampQty(params.get('emb_qty'));
    if (select && params.get('emb_style')) { var opt = qs(select, 'option[value="' + params.get('emb_style').replace(/[^0-9]/g, '') + '"]'); if (opt) select.value = opt.value; }
    if (need && /^\d{4}-\d{2}-\d{2}$/.test(params.get('emb_need') || '')) need.value = params.get('emb_need');

    // tier marks on the slider
    var marks = qs(root, '[data-emb-range-marks]');
    if (marks && range) {
      c.tiers.concat(quoteMin <= max ? [{ min: quoteMin, off: null }] : []).forEach(function (t) {
        if (t.min > max) return;
        var m = document.createElement('span');
        m.className = 'emb-range__mark';
        m.dataset.min = t.min;
        var f = qtyToPos(t.min) / SCALE;
        m.style.left = 'calc(' + (f * 100) + '% + ' + (13 - f * 26) + 'px)';
        m.innerHTML = '<b>' + t.min + '+</b>' + (t.off ? '<span>' + t.off + '% off</span>' : '<span>Partner</span>');
        marks.appendChild(m);
      });
    }
    // fill the timeline notes from config
    function days(a) { return a[0] === a[1] ? a[0] + ' business day' + (a[0] === 1 ? '' : 's') : a[0] + '-' + a[1] + ' business days'; }
    setText(root, '[data-emb-tl-note="preview"]', days(pv));
    setText(root, '[data-emb-tl-note="production"]', days(pr) + ' after you approve');
    setText(root, '[data-emb-tl-note="arrive"]', 'Standard shipping, ' + days(sh));
    var sampleMin = c.sampleMin || 0;
    var express = c.express && c.express.days ? c.express : null;

    function basePrice() {
      if (select) return parseInt(select.options[select.selectedIndex].dataset.price, 10) || 0;
      return parseInt(root.dataset.price, 10) || 0;
    }
    function productUrl() { return select ? select.options[select.selectedIndex].dataset.url : root.dataset.url; }
    function timeline() {
      var start = startDay();
      var today = new Date();
      var preview = rangeBD(start, pv[0], pv[1]);
      var made = rangeBD(start, pv[0] + pr[0], pv[1] + pr[1]);
      var arrive = rangeBD(start, pv[0] + pr[0] + sh[0], pv[1] + pr[1] + sh[1]);
      setText(root, '[data-emb-tl="order"]', fmtShort(today));
      setText(root, '[data-emb-tl="preview"]', fmtRange(preview));
      setText(root, '[data-emb-tl="production"]', fmtRange(made));
      setText(root, '[data-emb-tl="arrive"]', fmtRange(arrive));
      if (!status) return;
      if (!need || !need.value) { status.hidden = true; status.className = 'emb-hc__status'; return; }
      var p = need.value.split('-');
      var nd = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
      status.hidden = false;
      status.className = 'emb-hc__status';
      if (nd >= arrive[1]) {
        status.classList.add('is-ok');
        status.innerHTML = '<b>You are on time.</b> Standard shipping arrives by ' + fmtShort(arrive[1]) + ', before ' + fmtShort(nd) + '.';
        return;
      }
      var head = nd >= arrive[0]
        ? '<b>Tight with standard shipping.</b> It arrives ' + fmtRange(arrive) + '.'
        : '<b>Standard shipping arrives too late</b> (' + fmtRange(arrive) + ').';
      var opts = '';
      var anyFit = false;
      if (express) {
        var ra = rangeBD(start, express.days[0], express.days[1]);
        var fits = nd >= ra[1] ? 'is-fit' : nd >= ra[0] ? 'is-maybe' : 'is-no';
        anyFit = fits !== 'is-no';
        var tag = fits === 'is-fit' ? 'Arrives in time' : fits === 'is-maybe' ? 'Possible' : 'Too late';
        head += ' ' + (express.hint || 'Faster option:');
        opts = '<li class="' + fits + '"><span><b>' + express.label + '</b> ' + express.days[0] + '-' + express.days[1] + ' business days total, ' + fmtRange(ra) + '</span><span>' + (express.price ? express.price + ' \u00b7 ' : '') + tag + '</span></li>';
      } else if (c.rush && c.rush.length) {
        head += ' Faster options:';
        opts = c.rush.map(function (r) {
          var rr = rangeBD(start, pv[0] + pr[0] + r.days[0], pv[1] + pr[1] + r.days[1]);
          var f = nd >= rr[1] ? 'is-fit' : nd >= rr[0] ? 'is-maybe' : 'is-no';
          if (f !== 'is-no') anyFit = true;
          return '<li class="' + f + '"><span><b>' + r.label + '</b> ' + fmtRange(rr) + '</span><span>' + (r.price ? r.price : 'rate at checkout') + ' \u00b7 ' + (f === 'is-fit' ? 'Arrives in time' : f === 'is-maybe' ? 'Possible' : 'Too late') + '</span></li>';
        }).join('');
      }
      status.classList.add(nd >= arrive[0] || anyFit ? 'is-tight' : 'is-late');
      status.innerHTML = head + (opts ? '<ul>' + opts + '</ul>' : '') +
        '<p>Tip: approve your preview the same day to save time.' + (rushUrl ? ' <a href="' + rushUrl + '">Need it sooner? Talk to us</a>' : '') + '</p>';
    }
    function render() {
      var qty = clampQty(qtyInput.value);
      var base = basePrice();
      var t = tierFor(qty);
      var off = t ? t.off : 0;
      var unit = Math.round(base * (100 - off) / 100);
      var total = unit * qty;
      setText(root, '[data-emb-out-unit]', money(unit));
      setText(root, '[data-emb-out-base]', off ? money(base) : '');
      setText(root, '[data-emb-out-total]', money(total));
      setText(root, '[data-emb-out-saved]', money(base * qty - total));
      setText(root, '[data-emb-out-tier]', off ? off + '% off' : 'Standard price');
      var nt = nextTier(qty);
      var nx = qs(root, '[data-emb-out-next]');
      var sampleTxt = c.sampleNudge ? ' + ' + c.sampleNudge : '';
      if (nx) nx.textContent = nt
        ? 'Add ' + (nt.min - qty) + ' more to unlock ' + nt.off + '% off' + (sampleMin && nt.min === sampleMin ? sampleTxt : '')
        : 'Best online price unlocked' + (sampleMin && qty >= sampleMin ? sampleTxt : '');
      qsa(root, '[data-emb-sample]').forEach(function (el) { el.hidden = !(sampleMin && qty >= sampleMin); });
      show(qs(root, '[data-emb-partner]'), qty >= quoteMin);
      show(qs(root, '[data-emb-cta-online]'), qty < quoteMin);
      show(qs(root, '[data-emb-cta-quote]'), qty >= quoteMin);
      if (range) {
        var pos = qtyToPos(qty);
        if (posToQty(parseInt(range.value, 10)) !== Math.min(qty, max)) range.value = pos;
        root.style.setProperty('--emb-pct', (pos / SCALE * 100) + '%');
        range.setAttribute('aria-valuetext', qty + (qty >= max ? '+' : '') + ' ' + UN);
      }
      qsa(root, '.emb-range__mark').forEach(function (m) { m.classList.toggle('is-hit', qty >= parseInt(m.dataset.min, 10)); });
      qsa(root, '[data-emb-chip]').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.dataset.embChip, 10) === qty)); });
      var url = productUrl();
      if (go) {
        go.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'emb_qty=' + qty;
        if (ctaTpl) go.textContent = ctaTpl.replace('[qty]', qty).split(capW(UN)).join(qty === 1 ? capW(U1) : capW(UN));
      }
      var link = qs(root, '[data-emb-product-link]');
      if (link) link.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'emb_qty=' + qty;
      try { window.sessionStorage.setItem('emb_qty', String(qty)); } catch (e) {}
      timeline();
    }
    qsa(root, '[data-emb-step]').forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = clampQty(clampQty(qtyInput.value) + parseInt(b.dataset.embStep, 10)); render(); });
    });
    qsa(root, '[data-emb-chip]').forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = b.dataset.embChip; render(); }); });
    if (range) range.addEventListener('input', function () { qtyInput.value = posToQty(parseInt(range.value, 10)); render(); });
    qtyInput.addEventListener('input', render);
    qtyInput.addEventListener('blur', function () { qtyInput.value = clampQty(qtyInput.value); render(); });
    if (select) select.addEventListener('change', render);
    if (need) {
      var minD = startDay(); need.min = minD.getFullYear() + '-' + String(minD.getMonth() + 1).padStart(2, '0') + '-' + String(minD.getDate()).padStart(2, '0');
      need.addEventListener('change', render); need.addEventListener('input', render);
    }
    function shareEstimate(btn) {
      var u = new URL(window.location.href);
      u.searchParams.set('emb_qty', clampQty(qtyInput.value));
      if (select) u.searchParams.set('emb_style', select.value);
      if (need && need.value) u.searchParams.set('emb_need', need.value); else u.searchParams.delete('emb_need');
      u.hash = root.id || '';
      var label = btn.textContent;
      var text = clampQty(qtyInput.value) + ' custom embroidered ' + UN + ': ' + qs(root, '[data-emb-out-total]').textContent + ' estimated';
      if (navigator.share) { navigator.share({ title: document.title, text: text, url: u.toString() }).catch(function () {}); return; }
      var done = function () { btn.textContent = 'Link copied!'; window.setTimeout(function () { btn.textContent = label; }, 2200); };
      if (navigator.clipboard) navigator.clipboard.writeText(u.toString()).then(done, function () { window.prompt('Copy this link:', u.toString()); });
      else window.prompt('Copy this link:', u.toString());
    }
    window.EmbB2B.shareEstimate = shareEstimate;
    if (share) share.addEventListener('click', function () { shareEstimate(share); });
    render();
  }

  /* ---------- 4. need-by date checker ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) days--;
    }
    return d;
  }
  function startDay() {
    var c = config();
    var now = new Date();
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (now.getHours() >= (c.cutoffHour || 12) || d.getDay() === 0 || d.getDay() === 6) d = addBusinessDays(d, 1);
    return d;
  }
  function fmtDate(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function initNeedBy(root) {
    if (root.dataset.embReady) return;
    root.dataset.embReady = '1';
    var c = config();
    var input = qs(root, 'input[type="date"]');
    var out = qs(root, '[data-emb-needby-out]');
    var prev = c.previewDays || [0, 0];
    var prod = c.productionDays || [0, 0];
    var ship = c.shippingDays || [0, 0];
    var start = startDay();
    var fastest = addBusinessDays(start, prev[0] + prod[0] + ship[0]);
    var safe = addBusinessDays(start, prev[1] + prod[1] + ship[1]);
    var ex = c.express && c.express.days ? c.express : null;
    var exSafe = ex ? addBusinessDays(start, ex.days[1]) : null;
    var minAttr = new Date(start.getTime()); minAttr.setDate(minAttr.getDate() + 1);
    input.min = minAttr.toISOString().slice(0, 10);
    setText(root, '[data-emb-needby-safe]', fmtDate(safe));
    function render() {
      out.className = 'emb-needby__out';
      if (!input.value) { out.textContent = ''; return; }
      var p = input.value.split('-');
      var need = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
      var rushLink = root.dataset.rush ? ' <a href="' + root.dataset.rush + '">' + (root.dataset.rushLabel || 'Contact us about rush options') + '</a>' : '';
      if (ex && need < safe && need >= exSafe) rushLink = ' <b>' + ex.label + '</b> (' + ex.days[0] + '-' + ex.days[1] + ' business days total) arrives by ' + fmtDate(exSafe) + '.' + rushLink;
      if (need >= safe) {
        out.classList.add('is-ok');
        out.innerHTML = '<b>Yes, you are on time.</b> Order by today and your hats should arrive by ' + fmtDate(safe) + '.';
      } else if (need >= fastest) {
        out.classList.add('is-tight');
        out.innerHTML = '<b>Tight, but possible.</b> Most orders arrive between ' + fmtDate(fastest) + ' and ' + fmtDate(safe) + '. Approve your preview quickly and add your date in the order notes.' + rushLink;
      } else {
        out.classList.add('is-late');
        out.innerHTML = '<b>Too soon for standard delivery.</b> The earliest standard arrival is ' + fmtDate(fastest) + '.' + rushLink;
      }
      // copy the date into a "need by" field of the quote form app, when one exists in the same section
      var section = root.closest('section');
      var target = section && section.querySelector('input[name*="need" i], input[name*="date" i]:not([data-emb-own])');
      if (target && target !== input && !target.value) { target.value = input.value; target.dispatchEvent(new Event('input', { bubbles: true })); }
    }
    input.addEventListener('change', render);
    input.addEventListener('input', render);
  }

  /* ---------- 5. team order builder ---------- */
  function parseRows(text) {
    var rows = [];
    text.split(/\r?\n/).forEach(function (line) {
      if (!line.trim()) return;
      var cells = line.indexOf('\t') > -1 ? line.split('\t') : line.split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/);
      cells = cells.map(function (c) { return c.replace(/^"|"$/g, '').trim(); });
      var head = cells.join(' ').toLowerCase();
      if (/^(name|names|player|text)\b/.test(head) && /(number|no\.?|#|color|colour)/.test(head)) return; // header row
      rows.push({ name: cells[0] || '', number: cells[1] || '', color: cells[2] || '' });
    });
    return rows;
  }
  function initTeam(root) {
    if (root.dataset.embReady) return;
    root.dataset.embReady = '1';
    var products = {};
    try { products = JSON.parse(qs(root, 'script[data-emb-team-products]').textContent); } catch (e) { return; }
    var productSel = qs(root, '[data-emb-team-product]');
    var tbody = qs(root, '[data-emb-team-rows]');
    var tpl = qs(root, 'template[data-emb-team-row]');
    var allColor = qs(root, '[data-emb-team-allcolor]');
    var paste = qs(root, '[data-emb-team-paste]');
    var csv = qs(root, '[data-emb-team-csv]');
    var msg = qs(root, '[data-emb-team-msg]');
    var addBtn = qs(root, '[data-emb-team-add]');
    var maxRows = parseInt(root.dataset.maxRows || '300', 10);
    var quoteMin = config().quoteMin || 100;

    function product() { return products[productSel.value]; }
    function colorOptions(selectEl, keep) {
      var p = product();
      var prev = keep ? selectEl.value : '';
      selectEl.innerHTML = '';
      p.variants.forEach(function (v) {
        if (!v.available) return;
        var o = document.createElement('option');
        o.value = v.id; o.textContent = v.title; o.dataset.price = v.price;
        selectEl.appendChild(o);
      });
      if (prev && qsa(selectEl, 'option').some(function (o) { return o.value === prev; })) selectEl.value = prev;
    }
    function matchColor(name) {
      if (!name) return null;
      var n = name.toLowerCase().replace(/\s+/g, '');
      var hit = null;
      product().variants.forEach(function (v) {
        if (!v.available || hit) return;
        if (v.title.toLowerCase().replace(/\s+/g, '') === n) hit = v.id;
      });
      return hit;
    }
    function rows() { return qsa(tbody, 'tr'); }
    function isFilled(tr) { return !!(qs(tr, '[data-emb-row-name]').value.trim() || qs(tr, '[data-emb-row-number]').value.trim()); }
    function filledRows() { return rows().filter(isFilled); }
    function dropEmpty() { rows().forEach(function (tr) { if (!isFilled(tr)) tr.remove(); }); }
    function renumber() { rows().forEach(function (tr, i) { setText(tr, '[data-emb-row-n]', String(i + 1)); }); }
    function addRow(data) {
      if (rows().length >= maxRows) { say('You can add up to ' + maxRows + ' people here. For bigger orders, please request a quote.', 'warn'); return null; }
      var tr = tpl.content.firstElementChild.cloneNode(true);
      var color = qs(tr, '[data-emb-row-color]');
      colorOptions(color, false);
      color.value = (data && matchColor(data.color)) || allColor.value || color.value;
      if (data) { qs(tr, '[data-emb-row-name]').value = data.name || ''; qs(tr, '[data-emb-row-number]').value = data.number || ''; }
      qs(tr, '[data-emb-row-remove]').addEventListener('click', function () { tr.remove(); renumber(); summary(); });
      qsa(tr, 'input,select').forEach(function (el) { el.addEventListener('input', summary); el.addEventListener('change', summary); });
      tbody.appendChild(tr);
      renumber();
      return tr;
    }
    function say(text, kind) { msg.textContent = text; msg.className = 'emb-team__msg' + (kind ? ' is-' + kind : ''); }
    function summary() {
      var list = filledRows();
      var qty = list.length;
      var total = 0;
      var base = 0;
      var t = tierFor(qty);
      var off = t ? t.off : 0;
      list.forEach(function (tr) {
        var sel = qs(tr, '[data-emb-row-color]');
        var o = sel.options[sel.selectedIndex];
        var price = o ? parseInt(o.dataset.price, 10) : 0;
        base += price;
        total += Math.round(price * (100 - off) / 100);
      });
      setText(root, '[data-emb-team-qty]', String(qty));
      setText(root, '[data-emb-team-tier]', off ? off + '% off' : 'Standard price');
      setText(root, '[data-emb-team-total]', money(total));
      setText(root, '[data-emb-team-saved]', money(base - total));
      var nt = nextTier(qty);
      setText(root, '[data-emb-team-next]', qty >= quoteMin ? 'Ordering ' + quoteMin + '+ hats? A custom quote may get you an even better price.' : nt ? 'Add ' + (nt.min - qty) + ' more to unlock ' + nt.off + '% off.' : '');
      addBtn.disabled = qty === 0;
    }
    productSel.addEventListener('change', function () {
      colorOptions(allColor, true);
      rows().forEach(function (tr) { colorOptions(qs(tr, '[data-emb-row-color]'), true); });
      summary();
    });
    qs(root, '[data-emb-team-addrow]').addEventListener('click', function () { var tr = addRow(); if (tr) qs(tr, '[data-emb-row-name]').focus(); summary(); });
    qs(root, '[data-emb-team-applyall]').addEventListener('click', function () {
      rows().forEach(function (tr) { qs(tr, '[data-emb-row-color]').value = allColor.value; });
      summary();
    });
    qs(root, '[data-emb-team-pastebtn]').addEventListener('click', function () {
      var list = parseRows(paste.value);
      if (!list.length) { say('Paste one person per line: Name, Number, Color (number and color are optional).', 'warn'); return; }
      dropEmpty();
      list.forEach(addRow);
      paste.value = '';
      say(list.length + ' people added. Check names and colors below.', 'ok');
      summary();
    });
    csv.addEventListener('change', function () {
      var f = csv.files && csv.files[0];
      if (!f) return;
      var reader = new FileReader();
      reader.onload = function () {
        var list = parseRows(String(reader.result));
        dropEmpty();
        list.forEach(addRow);
        say(list.length + ' people imported from ' + f.name + '.', 'ok');
        csv.value = '';
        summary();
      };
      reader.readAsText(f);
    });

    addBtn.addEventListener('click', function () {
      var list = filledRows();
      if (!list.length) { say('Add at least one person (a name or a number).', 'warn'); return; }
      var front = qs(root, '[data-emb-team-front]').value.trim();
      var logoInput = qs(root, '[data-emb-team-logo]');
      var logo = logoInput.files && logoInput.files[0];
      var notes = qs(root, '[data-emb-team-notes]').value.trim();
      var needBy = qs(root, '[data-emb-team-needby]');
      if (!front && !logo) { say('Add your front text or upload a logo first.', 'warn'); return; }
      var groups = {};
      var order = [];
      list.forEach(function (tr) {
        var id = qs(tr, '[data-emb-row-color]').value;
        var name = qs(tr, '[data-emb-row-name]').value.trim();
        var num = qs(tr, '[data-emb-row-number]').value.trim();
        if (!groups[id]) { groups[id] = []; order.push(id); }
        groups[id].push((name && name !== '-' ? name : 'No name') + (num ? ' #' + num : ''));
      });
      var teamId = 'T' + Date.now().toString(36).toUpperCase();
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      say('Adding ' + list.length + ' hats to your cart...', '');
      var logoUrl = '';
      var chain = Promise.resolve();
      order.forEach(function (id, idx) {
        chain = chain.then(function () {
          var fd = new FormData();
          fd.append('id', id);
          fd.append('quantity', String(groups[id].length));
          fd.append('properties[Order type]', 'Team order ' + teamId);
          if (front) fd.append('properties[Front design]', front);
          if (logo && idx === 0) fd.append('properties[Logo]', logo, logo.name);
          else if (logoUrl) fd.append('properties[Logo]', logoUrl);
          fd.append('properties[Side names]', groups[id].join('; '));
          if (notes) fd.append('properties[Notes]', notes);
          if (needBy && needBy.value) fd.append('properties[Need by]', needBy.value);
          fd.append('properties[_team_size]', String(list.length));
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
          }).then(function (r) {
            return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
          }).then(function (item) {
            if (idx === 0 && logo && item && item.properties && item.properties.Logo) logoUrl = item.properties.Logo;
          });
        });
      });
      chain.then(function () {
        say('Done! Taking you to your cart...', 'ok');
        window.location.href = root.dataset.cartUrl || '/cart';
      }).catch(function (err) {
        say('Something went wrong: ' + err.message + '. Your cart may have part of the order, please check it or contact us.', 'warn');
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
      });
    });

    colorOptions(allColor, false);
    for (var i = 0; i < parseInt(root.dataset.startRows || '3', 10); i++) addRow();
    summary();
  }

  /* ---------- 6. tier progress (product page) ---------- */
  function initProgress(root) {
    if (root.dataset.embReady) return;
    root.dataset.embReady = '1';
    var qtySel = root.dataset.qtySelector || 'form[action*="/cart/add"] [name="quantity"]';
    var pre = new URLSearchParams(window.location.search).get('emb_qty');
    if (pre) {
      var qEl = document.querySelector(qtySel);
      if (qEl) { qEl.value = clampQty(pre); qEl.dispatchEvent(new Event('input', { bubbles: true })); qEl.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var cartQty = 0;
    var max = config().tiers.length ? config().tiers[config().tiers.length - 1].min : 1;
    var marks = qs(root, '[data-emb-progress-marks]');
    if (marks && !marks.children.length) {
      config().tiers.forEach(function (t) {
        var m = document.createElement('span');
        m.className = 'emb-progress__mark';
        m.dataset.embProgressMark = t.min;
        m.style.left = Math.round(t.min / max * 100) + '%';
        m.innerHTML = '<b>' + t.min + '+</b><br>' + t.off + '% off';
        marks.appendChild(m);
      });
    }
    function pageQty() {
      var el = document.querySelector(qtySel);
      return el ? clampQty(el.value) : 1;
    }
    function render() {
      var qty = cartQty + pageQty();
      var t = tierFor(qty);
      var nt = nextTier(qty);
      var fill = qs(root, '[data-emb-progress-fill]');
      if (fill) fill.style.width = Math.min(100, Math.round(qty / max * 100)) + '%';
      var text = qs(root, '[data-emb-progress-text]');
      if (!text) return;
      if (nt) {
        var need = nt.min - qty;
        text.innerHTML = 'Add <b>' + need + ' more ' + (need === 1 ? 'hat' : 'hats') + '</b> to get <b>' + nt.off + '% off</b>' + (t ? ' (now ' + t.off + '% off)' : '') + '.';
      } else if (t) {
        text.innerHTML = 'Nice! Your order gets <b>' + t.off + '% off</b> at checkout.';
      }
      qsa(root, '[data-emb-progress-mark]').forEach(function (m) { m.classList.toggle('is-hit', qty >= parseInt(m.dataset.embProgressMark, 10)); });
    }
    function loadCart() {
      return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartQty = c.item_count || 0; render(); })
        .catch(render);
    }
    document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches(qtySel)) render(); });
    document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches(qtySel)) render(); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('form[action*="/cart/add"] [type="submit"], [name="add"]')) window.setTimeout(loadCart, 1500);
      if (e.target.closest && e.target.closest('.js-change-quantity, [data-func="plus"], [data-func="minus"], .quantity-plus, .quantity-minus, button[name="plus"], button[name="minus"]')) window.setTimeout(render, 50);
    });
    ['cart:updated', 'cart:refresh', 'cart:change', 'theme:cart:change'].forEach(function (ev) { document.addEventListener(ev, loadCart); });
    loadCart();
  }

  /* ---------- 7. hero media carousel ---------- */
  function initMedia(root) {
    if (root.dataset.embReady) return;
    root.dataset.embReady = '1';
    var slides = qsa(root, '[data-emb-slide]');
    var thumbs = qsa(root, '[data-emb-thumb]');
    var n = slides.length;
    if (n < 2) return;
    var cur = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = Math.max(2000, parseInt(root.dataset.speed || '5000', 10));
    var playing = root.dataset.autoplay === 'true' && !reduce;
    var hover = false, inView = true, timer = null;
    var vBtn = qs(root, '[data-emb-video-toggle]');
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function syncVideoBtn() {
      if (!vBtn) return;
      var v = videoOf(slides[cur]);
      vBtn.hidden = !v;
      if (!v) return;
      var paused = v.paused;
      vBtn.classList.toggle('is-paused', paused);
      vBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    function videoOf(sl) { return qs(sl, 'video'); }
    function go(i) {
      cur = ((i % n) + n) % n;
      slides.forEach(function (sl, k) {
        var d = ((k - cur) % n + n) % n; if (d > n / 2) d -= n;
        sl.classList.toggle('is-cur', d === 0);
        sl.classList.toggle('is-prev', d === -1);
        sl.classList.toggle('is-next', d === 1);
        sl.classList.toggle('is-far', Math.abs(d) > 1);
        sl.classList.toggle('is-left', d < -1);
        sl.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
        qsa(sl, 'a,button,iframe').forEach(function (el) { if (d === 0) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
        // lazy media for the next slides: load images just before they are needed
        if (Math.abs(d) <= 1) qsa(sl, 'img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        var v = videoOf(sl);
        if (v) {
          if (d === 0 && inView && !v.dataset.embUserPaused) { v.muted = true; var p = v.play(); if (p && p.then) p.then(syncVideoBtn, syncVideoBtn); }
          else if (d !== 0) { v.pause(); }
          if (!v.dataset.embBound) { v.dataset.embBound = '1'; v.addEventListener('play', syncVideoBtn); v.addEventListener('pause', syncVideoBtn); }
        }
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      syncVideoBtn();
    }
    function tick() {
      window.clearTimeout(timer);
      if (!playing || hover || !inView) return;
      timer = window.setTimeout(function () { go(cur + 1); tick(); }, speed);
    }
    function setPlaying(on) { playing = on; tick(); }
    // the small button only pauses or plays the video on screen; slides keep their own rhythm
    if (vBtn) vBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var v = videoOf(slides[cur]);
      if (!v) return;
      if (v.paused) { delete v.dataset.embUserPaused; v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.dataset.embUserPaused = '1'; v.pause(); }
      syncVideoBtn();
    });
    var prevB = qs(root, '[data-emb-media-prev]'), nextB = qs(root, '[data-emb-media-next]');
    if (prevB) prevB.addEventListener('click', function () { go(cur - 1); tick(); });
    if (nextB) nextB.addEventListener('click', function () { go(cur + 1); tick(); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); tick(); }); });
    slides.forEach(function (sl, k) { sl.addEventListener('click', function (e) { if (k !== cur) { e.preventDefault(); go(k); tick(); } }); });
    // pause while a desktop visitor hovers or tabs through; taps on phones never freeze the slides
    if (canHover) {
      root.addEventListener('mouseenter', function () { hover = true; tick(); });
      root.addEventListener('mouseleave', function () { hover = false; tick(); });
    }
    root.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches(':focus-visible')) { hover = true; tick(); } });
    root.addEventListener('focusout', function () { if (!canHover || !root.matches(':hover')) { hover = false; tick(); } });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(cur - 1); tick(); }
      if (e.key === 'ArrowRight') { go(cur + 1); tick(); }
    });
    // swipe
    var stage = qs(root, '.emb-media__stage') || root;
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { go(cur + (dx < 0 ? 1 : -1)); tick(); }
      x0 = null;
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        var v = videoOf(slides[cur]);
        if (v) { if (inView && !v.dataset.embUserPaused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else if (!inView) v.pause(); }
        tick();
      }, { threshold: 0.25 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () { inView = !document.hidden; tick(); });
    // a visitor who starts an embedded video takes over: stop autoplay
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-emb-play]')) setPlaying(false); }, true);
    go(0);
    setPlaying(playing);
  }

  /* ---------- 8. click-to-play video (gallery tiles + YouTube/Vimeo facades) ---------- */
  function embedUrl(url) {
    var m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
    if (m) return 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&mute=1&playsinline=1&rel=0';
    m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1&muted=1';
    return '';
  }
  function initPlay(btn) {
    if (btn.dataset.embReady) return;
    btn.dataset.embReady = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var box = btn.closest('[data-emb-play-box]') || btn.parentNode;
      var ext = btn.dataset.embPlay;
      if (ext) {
        var src = embedUrl(ext);
        if (!src) { window.open(ext, '_blank', 'noopener'); return; }
        var f = document.createElement('iframe');
        f.src = src; f.title = btn.getAttribute('aria-label') || 'Video';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true;
        f.className = 'emb-play__frame';
        box.appendChild(f);
        btn.hidden = true;
        return;
      }
      var v = qs(box, 'video');
      if (!v) return;
      v.controls = true; v.muted = false;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      btn.hidden = true;
    });
  }

  /* ---------- 9. "Message us" links open the site chat ---------- */
  function openChat() {
    try {
      if (window.tidioChatApi) { window.tidioChatApi.show(); window.tidioChatApi.open(); return true; }
      if (window.$crisp) { window.$crisp.push(['do', 'chat:open']); return true; }
      if (window.Tawk_API && window.Tawk_API.maximize) { window.Tawk_API.maximize(); return true; }
      if (typeof window.zE === 'function') { window.zE('messenger', 'open'); return true; }
      if (window.GorgiasChat && window.GorgiasChat.open) { window.GorgiasChat.open(); return true; }
      if (window.Intercom) { window.Intercom('show'); return true; }
      if (window.HubSpotConversations && window.HubSpotConversations.widget) { window.HubSpotConversations.widget.open(); return true; }
    } catch (e) {}
    // Shopify Inbox: the bubble is a button inside one or more shadow roots
    var bubble = deepFind(document, 'button.activator, button[part="activator"], button.chat-toggle, .chat-app > button');
    if (bubble) {
      if (bubble.getAttribute('aria-expanded') !== 'true') bubble.click();
      return true;
    }
    var inbox = document.querySelector('inbox-online-store-chat, #ShopifyChat');
    if (inbox) {
      // the widget is on the page but not ready yet: Shopify Inbox opens itself when the URL has ?chat
      var u = new URL(window.location.href); u.searchParams.set('chat', ''); u.hash = '';
      window.location.href = u.toString().replace('chat=', 'chat');
      return true;
    }
    var sel = (document.querySelector('[data-emb-sticky]') || {}).dataset;
    var list = ['.chat-button', '[class*="chat-launcher"]', '[class*="chat-bubble"]', 'button[aria-label*="chat" i]'];
    if (sel && sel.chat) list.unshift(sel.chat);
    for (var i = 0; i < list.length; i++) {
      var els = [];
      try { els = qsa(document, list[i]); } catch (e) { els = []; }
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        if (el.closest('.emb-b2b') || el.closest('[data-emb-sticky]')) continue; // never our own buttons
        if (el.shadowRoot) {
          var btn = el.shadowRoot.querySelector('button');
          if (btn) { btn.click(); return true; }
          continue;
        }
        if (el.tagName === 'BUTTON' || el.tagName === 'A' || el.getAttribute('role') === 'button') { el.click(); return true; }
      }
    }
    return false;
  }
  function deepFind(root, sel) {
    var hit = null;
    try { hit = root.querySelector(sel); } catch (e) { hit = null; }
    if (hit && !(hit.closest && hit.closest('.emb-b2b, [data-emb-sticky]'))) return hit;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) { var h = deepFind(all[i].shadowRoot, sel); if (h) return h; }
    }
    return null;
  }
  function initChatLinks() {
    if (window.EmbB2B.chatReady) return;
    window.EmbB2B.chatReady = true;
    // capture phase, so theme scripts that hijack "#" links (smooth scroll) never see this click
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#chat"], a[href$="/#chat"], [data-emb-chat]');
      if (!a) return;
      e.preventDefault();
      e.stopPropagation();
      if (openChat()) return;
      // chat widgets often load a few seconds after the page: wait for it, then fall back
      var tries = 0;
      var t = window.setInterval(function () {
        tries++;
        if (openChat()) { window.clearInterval(t); return; }
        if (tries >= 12) {
          window.clearInterval(t);
          if (a.dataset.fallback) { window.location.href = a.dataset.fallback; return; }
          var u = new URL(window.location.href); u.searchParams.set('chat', ''); u.hash = '';
          window.location.href = u.toString().replace('chat=', 'chat');
        }
      }, 250);
    }, true);
    window.EmbB2B.openChat = openChat;
  }

  /* ---------- 10. share-estimate buttons outside the calculator ---------- */
  function initShareButton(btn) {
    if (btn.dataset.embReady) return;
    btn.dataset.embReady = '1';
    btn.addEventListener('click', function () {
      if (window.EmbB2B.shareEstimate) { window.EmbB2B.shareEstimate(btn); return; }
      var calc = document.querySelector('[data-emb-calc]');
      if (calc) calc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- 11. tabs (hat lines), "show all colors", photo zoom ---------- */
  function initTabs(root) {
    if (root.dataset.embReady) return;
    root.dataset.embReady = '1';
    var tabs = qsa(root, '[role="tab"]');
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (k) { e.preventDefault(); select(tabs[(i + k + tabs.length) % tabs.length], true); }
      });
    });
    qsa(root, '[data-emb-colors-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = btn.parentNode.querySelector('.emb-rcolors');
        var first = null;
        qsa(list, 'li.is-more').forEach(function (li) { li.hidden = false; if (!first) first = li; });
        btn.hidden = true;
        var f = first && first.querySelector('button');
        if (f) f.focus({ preventScroll: true });
      });
    });
  }
  function initZoom() {
    if (window.EmbB2B.zoomReady) return;
    window.EmbB2B.zoomReady = true;
    var dlg = null;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-emb-zoom]');
      if (!b) return;
      e.preventDefault();
      if (!dlg) {
        dlg = document.createElement('dialog');
        dlg.className = 'emb-zoom';
        dlg.innerHTML = '<button type="button" class="emb-zoom__x" aria-label="Close">\u00d7</button><img alt=""><p></p>';
        document.body.appendChild(dlg);
        dlg.addEventListener('click', function (ev) { if (ev.target === dlg || ev.target.closest('.emb-zoom__x')) dlg.close(); });
      }
      var img = b.querySelector('img');
      dlg.querySelector('img').src = b.dataset.embZoom;
      dlg.querySelector('img').alt = img ? img.alt : '';
      var name = b.parentNode.querySelector('.emb-rcolors__name');
      dlg.querySelector('p').textContent = name ? name.textContent : '';
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    });
  }

  /* ---------- 12. mobile: horizontal rows move on their own ---------- */
  function initAutoSlide(el) {
    if (el.dataset.embAuto) return;
    el.dataset.embAuto = '1';
    var mq = window.matchMedia('(max-width: 720px)');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var speed = parseInt(el.dataset.embSpeed || '3500', 10);
    var inView = false, holdUntil = 0;
    function items() {
      return Array.prototype.filter.call(el.children, function (c) {
        return c.offsetWidth > 0 && !c.hidden && !c.classList.contains('emb-badge__sep');
      });
    }
    function step() {
      if (!mq.matches || !inView || document.hidden || Date.now() < holdUntil) return;
      if (el.scrollWidth <= el.clientWidth + 4) return;
      var box = el.getBoundingClientRect();
      if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 6) { el.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      var list = items(), target = null;
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.left > box.left + 8) { target = r.left - box.left; break; }
      }
      if (target === null) { el.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      el.scrollBy({ left: target, behavior: 'smooth' });
    }
    function hold() { holdUntil = Date.now() + 6000; }
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { el.addEventListener(ev, hold, { passive: true }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }, { threshold: 0.5 }).observe(el);
    } else { inView = true; }
    window.setInterval(step, speed);
  }

  /* ---------- 13. date fields open the calendar on tap ---------- */
  function initDate(input) {
    if (input.dataset.embDate) return;
    input.dataset.embDate = '1';
    input.addEventListener('click', function () {
      if (typeof input.showPicker === 'function') { try { input.showPicker(); } catch (e) {} }
    });
  }

  /* ---------- boot ---------- */
  function init(root) {
    var r = root || document;
    qsa(r, '[data-emb-more-wrap]').forEach(initMore);
    qsa(r, '[data-emb-sticky]').forEach(initSticky);
    qsa(r, '[data-emb-calc]').forEach(initCalc);
    qsa(r, '[data-emb-needby]').forEach(initNeedBy);
    qsa(r, '[data-emb-team]').forEach(initTeam);
    qsa(r, '[data-emb-progress]').forEach(initProgress);
    qsa(r, '[data-emb-media]').forEach(initMedia);
    qsa(r, '[data-emb-play]').forEach(initPlay);
    qsa(r, '[data-emb-share-est]').forEach(initShareButton);
    qsa(r, '[data-emb-tabs]').forEach(initTabs);
    qsa(r, '.emb-b2b .emb-slide, .emb-logos__list, .emb-gallery__grid, .emb-ticks--stack, .emb-design__chips').forEach(initAutoSlide);
    qsa(r, '.emb-b2b input[type="date"]').forEach(initDate);
    initZoom();
    initChatLinks();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { CONFIG = null; init(e.target); });
})();
